import CitySEOHead from "@/components/feature/CitySEOHead";
import PonteVedraBeachHeroSection from "./components/HeroSection";
import PonteVedraBeachStickyNav from "./components/StickyNav";
import PonteVedraBeachProcessingTimeSection from "./components/ProcessingTimeSection";
import PonteVedraBeachServicesSection from "./components/ServicesSection";
import PonteVedraBeachLocalAreaSection, { landmarks as pontevedraLandmarks } from "./components/LocalAreaSection";
import PonteVedraBeachTravelTimingSection from "./components/TravelTimingSection";
import PonteVedraBeachDestinationsSection from "./components/DestinationsSection";
import PonteVedraBeachTestimonialsSection from "./components/TestimonialsSection";
import PonteVedraBeachAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import PonteVedraBeachComparisonSection from "./components/ComparisonSection";
import PonteVedraBeachMistakesSection from "./components/MistakesSection";
import PonteVedraBeachHowItWorksSection from "./components/HowItWorksSection";
import PonteVedraBeachFAQSection, { faqs } from "./components/FAQSection";
import PonteVedraBeachHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import PonteVedraBeachFinalCTA from "./components/FinalCTA";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

const areaServedList = [
  { "@type": "City", name: "Ponte Vedra Beach" },
  { "@type": "City", name: "Jacksonville Beach" },
  { "@type": "City", name: "Nocatee" },
  { "@type": "City", name: "St. Augustine" },
  { "@type": "City", name: "Atlantic Beach" },
  { "@type": "City", name: "Sawgrass" },
  { "@type": "City", name: "Palm Valley" },
  { "@type": "AdministrativeArea", name: "St. Johns County" },
];

const serviceAreaDesc = "Fast Passport Center is a registered U.S. Department of State passport courier serving Ponte Vedra Beach, Jacksonville Beach, Nocatee, and St. Johns County with expedited passport processing as fast as 24 hours. A+ BBB rated.";

export default function PonteVedraBeachPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Ponte Vedra Beach"
        state="Florida"
        stateAbbr="FL"
        route="/ponte-vedra-beach"
        title="Emergency Passport Ponte Vedra Beach, FL — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Ponte Vedra Beach, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving St. Johns County golfers, resort families, and travelers."
        geoPlacename="Ponte Vedra Beach, Florida"
        geoPosition="30.2397;-81.3853"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Florida"
        statePageRoute="/states/florida"
        areaServedList={areaServedList}
        serviceAreaDesc={serviceAreaDesc}
        landmarks={pontevedraLandmarks}
      />
      <PonteVedraBeachHeroSection />
      <PonteVedraBeachStickyNav />
      <PonteVedraBeachLocalAreaSection />
      <PonteVedraBeachProcessingTimeSection />
      <PonteVedraBeachServicesSection />
      <PonteVedraBeachTravelTimingSection />
      <PonteVedraBeachDestinationsSection />
      <PonteVedraBeachTestimonialsSection />
      <PonteVedraBeachAcceptanceFacilitiesSection />
      <PonteVedraBeachComparisonSection />
      <PonteVedraBeachMistakesSection />
      <PonteVedraBeachHowItWorksSection />
      <PonteVedraBeachFAQSection />
      <PonteVedraBeachHelpfulResourcesSection />
      <PonteVedraBeachFinalCTA />
    </div>
  );
}